import { createSlice } from "@reduxjs/toolkit";
const initialState = {
  BintransferHead: {
    DocType: "",
    DocTypName: "",
    DocNo: 0,
    Date: new Date(),
    LocCode: "",
    Reason: "",
    Narration: "",
    Type: "",
    Status: "ENTER",
    UserCd: "",
    IP: "",
  },
  BinTransferList: [
    {
      DocTypCode: "",
      DocTypName: "",
      Date: "",
      Status: "",
    },
  ],
  BinTransferData: {
    loc: "",
    dateFrom: new Date(
      new Date().getFullYear(),
      new Date().getMonth(),
      new Date().getDate() - 10
    ),
    dateTo: new Date(),
    statusVal: "",
    DocNo: "",
  },
};

const SliceBinTransfer = createSlice({
  name: "BinTransfer",
  initialState: { value: initialState },

  reducers: {
    BintransferHead_Set: (state, action) => {
      state.value.BintransferHead = action.payload.BintransferHead;
    },
    BinTransferList_Set: (state, action) => {
      state.value.BinTransferList = action.payload.BinTransferList;
    },
    BinTransferData_Set: (state, action) => {
      state.value.BinTransferData = action.payload.BinTransferData;
    },
    Bintransfer_Init: (state) => {
      state.value = initialState;
    },
    BintransferHead_DocType: (state, action) => {
      state.value.BintransferHead.DocType = action.payload.DocType;
    },
  },
});

export const {
  BintransferHead_Set,
  Bintransfer_Init,
  BintransferHead_DocType,
  BinTransferList_Set,
  BinTransferData_Set,
} = SliceBinTransfer.actions;
export default SliceBinTransfer.reducer;
